import React from 'react';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import RoomContentWrapper, {
  RoomContentWrapperProps,
} from './RoomContentWrapper';
import AudioTracker, { AudioTrackerProps } from '../Tracking/AudioTracker';

const useStyles = makeStyles(() => ({
  audioPlayer: {
    background: '#000000',
    minHeight: 'inherit',
  },
}));

export interface RoomAudioContentProps
  extends RoomContentWrapperProps,
    AudioTrackerProps {}

const RoomAudioContent: React.FC<RoomAudioContentProps> = (
  props: RoomAudioContentProps
): JSX.Element => {
  const classes = useStyles();

  const {
    cover,
    disableDefaultCover,
    disableMinHeight,
    rounded,
    width,
    ...audioTrackerProps
  } = props;

  return (
    <RoomContentWrapper
      cover={cover}
      disableDefaultCover={disableDefaultCover}
      disableMinHeight={disableMinHeight}
      rounded={rounded}
      width={width}
    >
      <Box
        alignItems="center"
        className={classes.audioPlayer}
        display="flex"
        p={3}
      >
        <AudioTracker {...audioTrackerProps} />
      </Box>
    </RoomContentWrapper>
  );
};

export default RoomAudioContent;
